<template>
  <div class="flex flex-wrap justify-between items-center w-full px-4 py-2">
    <h1 style="font-weight: 700;font-size: 1.25rem; line-height: 1.75rem;">Parámetros Generales (SMMLV por vigencia)</h1>
    <button v-if="viewInterna === 'list'" type="button" @click="nuevoParametro()"
            class="flex items-center rounded-md border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Nuevo Parámetro
    </button>
    <button v-else type="button" @click="viewInterna = 'list'"
            class="px-4 py-2 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none">
      Volver
    </button>
  </div>

  <div class="mt-4 overflow-x-auto" v-if="viewInterna === 'list'">
    <table class="w-full table-auto">
      <thead>
      <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
        <th class="px-4 py-3">ID</th>
        <th class="px-4 py-3">Clave</th>
        <th class="px-4 py-3">Vigencia</th>
        <th class="px-4 py-3">Valor</th>
        <th class="px-4 py-3">Descripción</th>
        <th class="px-4 py-3">Opciones</th>
      </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(parametro, index) of collectionData" :key="index">
          <td class="px-4 py-4">{{ parametro.id }}</td>
          <td class="px-4 py-4">{{ parametro.clave }}</td>
          <td class="px-4 py-4">{{ parametro.vigencia }}</td>
          <td class="px-4 py-4 font-bold">$ {{ parseFloat(parametro.valor || 0).toLocaleString() }}</td>
          <td class="px-4 py-4">{{ parametro.descripcion }}</td>
          <td class="px-4 py-4">
            <button @click="editarParametro(parametro)"
                    class="items-center mx-1 px-2 py-2 text-white bg-indigo-500 rounded-md hover:bg-indigo-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z"/>
              </svg>
            </button>
            <button v-if="!parametro.estado" @click="cambiarEstado(parametro)"
                    class="items-center mx-1 px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"/>
              </svg>
            </button>
            <button v-else @click="cambiarEstado(parametro)"
                    class="items-center mx-1 px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-else class="bg-white px-4 py-5 sm:p-6">
    <div class="grid grid-cols-6 gap-6">
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="clave" class="block text-sm font-medium text-gray-700">Clave <span style="color: red">(*)</span></label>
        <input type="text" id="clave" v-model="formParametro.clave" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        <p class="mt-1 text-xs text-gray-500">Ej: SMMLV (salario mínimo mensual legal vigente).</p>
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="vigencia" class="block text-sm font-medium text-gray-700">Vigencia <span style="color: red">(*)</span></label>
        <input type="number" id="vigencia" v-model="formParametro.vigencia" placeholder="Ej: 2026" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="valor" class="block text-sm font-medium text-gray-700">Valor <span style="color: red">(*)</span></label>
        <input type="number" step="0.01" min="0.01" id="valor" v-model="formParametro.valor" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="descripcion" class="block text-sm font-medium text-gray-700">Descripción</label>
        <textarea id="descripcion" v-model="formParametro.descripcion" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"/>
      </div>
    </div>
    <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="guardarParametro()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Swal from "sweetalert2";
import { useAPIRest, swal, generateTextError } from "@/common/constants";
import { useAuth } from "@/components/auth/store/composables";

export default {
  name: 'ParametrosGeneralesCRUD',
  async setup() {
    const authStored = useAuth();
    const authToken = ref(authStored.authToken);
    const viewInterna = ref('list');
    const collectionData = ref([]);
    const formParametro = ref({ id: null, clave: 'SMMLV', vigencia: '', valor: '', descripcion: '' });

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_PARAMETROS_GENERALES_FINDALL, 'GET', authToken.value, undefined, undefined, 'application/json')
      .then(res => {
        collectionData.value = Array.isArray(res) ? res : [];
      });

    await listData();

    const nuevoParametro = () => {
      formParametro.value = { id: null, clave: 'SMMLV', vigencia: new Date().getFullYear(), valor: '', descripcion: '' };
      viewInterna.value = 'form';
    };

    const editarParametro = (parametro) => {
      formParametro.value = {
        id: parametro.id,
        clave: parametro.clave,
        vigencia: parametro.vigencia,
        valor: parametro.valor,
        descripcion: parametro.descripcion ?? '',
      };
      viewInterna.value = 'form';
    };

    const guardarParametro = async () => {
      let error = '';
      if (!formParametro.value.clave) error += 'El campo clave es obligatorio. <br>';
      if (!formParametro.value.vigencia) error += 'El campo vigencia es obligatorio. <br>';
      if (!formParametro.value.valor || parseFloat(formParametro.value.valor) <= 0) error += 'El valor es obligatorio y debe ser mayor a 0. <br>';

      if (error !== '') {
        Swal.fire({ title: error, icon: 'error', showCloseButton: true, focusConfirm: false });
        return;
      }

      const dataSave = {
        clave: formParametro.value.clave,
        vigencia: parseInt(formParametro.value.vigencia),
        valor: parseFloat(formParametro.value.valor),
        descripcion: formParametro.value.descripcion || null,
      };

      const resJSON = formParametro.value.id
        ? await useAPIRest(process.env.VUE_APP_NEST_PARAMETROS_GENERALES_UPDATE.replace(':id', formParametro.value.id), 'PATCH', authToken.value, dataSave, undefined, 'application/json')
        : await useAPIRest(process.env.VUE_APP_NEST_PARAMETROS_GENERALES_CREATE, 'POST', authToken.value, dataSave, undefined, 'application/json');

      if (resJSON && resJSON.id) {
        await swal.fire('Parámetro guardado con éxito', '', 'success');
        viewInterna.value = 'list';
        listData();
      } else {
        const textoError = generateTextError(resJSON);
        await swal.fire(textoError || 'Error al guardar el parámetro', '', 'error');
      }
    };

    const cambiarEstado = async (parametro) => {
      const resJSON = await useAPIRest(process.env.VUE_APP_NEST_PARAMETROS_GENERALES_FINDALL + '/estado/' + parametro.id, 'PATCH', authToken.value, {}, undefined, 'application/json');
      if (resJSON && resJSON.id) {
        listData();
      } else {
        const textoError = generateTextError(resJSON);
        await swal.fire(textoError || 'Error al cambiar el estado', '', 'error');
      }
    };

    return {
      viewInterna,
      collectionData,
      formParametro,
      listData,
      nuevoParametro,
      editarParametro,
      guardarParametro,
      cambiarEstado,
    };
  },
}
</script>
